import { useState, useEffect } from 'react';
import { getByFromCoords } from '../data/norwegianCities';

/**
 * Hook for å hente brukerens lokasjon basert på IP-adresse
 * Brukes for ikke-innloggede brukere for å vise relevante annonser
 */
const useIPLocation = () => {
  const [location, setLocation] = useState({
    fylkeId: null,
    byId: null,
    loading: true,
    error: null
  });

  useEffect(() => {
    const fetchLocation = async () => {
      // Sjekk om vi har lagret lokasjon i sessionStorage
      const cached = sessionStorage.getItem('minitask_ip_location');
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          setLocation({ ...parsed, loading: false, error: null });
          return;
        } catch {
          // Fortsett med å hente ny lokasjon
        }
      }

      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();

        if (data.latitude && data.longitude) {
          const result = getByFromCoords(data.latitude, data.longitude);
          
          if (result) {
            const locationData = {
              fylkeId: result.fylkeId,
              byId: result.byId,
              city: data.city,
              region: data.region,
              country: data.country_name
            };
            
            // Cache i sessionStorage
            sessionStorage.setItem('minitask_ip_location', JSON.stringify(locationData));
            
            setLocation({
              ...locationData,
              loading: false,
              error: null
            });
          } else {
            setLocation({
              fylkeId: null,
              byId: null,
              loading: false,
              error: 'Kunne ikke bestemme lokasjon'
            });
          }
        } else {
          setLocation({
            fylkeId: null,
            byId: null,
            loading: false,
            error: 'Ingen lokasjonsdata tilgjengelig'
          });
        }
      } catch (error) {
        console.error('IP location error:', error);
        setLocation({
          fylkeId: null,
          byId: null,
          loading: false,
          error: 'Kunne ikke hente lokasjon'
        });
      }
    };

    fetchLocation();
  }, []);

  return location;
};

export default useIPLocation;
